import React, { useCallback, useRef, useState } from 'react';
import { ATMButton, ATMModal } from 'shared-it-appmod-ui';
import {
  ToastSuccess,
  ToastError,
} from 'src/components/atoms/toaster/toaster.component';
import { IPolygon, IPolygonForm } from 'src/models/polygon.model';
import { usePolygonContext } from 'src/contexts/polygon.context';
import Lang from 'src/libraries/language';
import { actionTypes } from 'src/ducks/polygon.duck';
import { getPolygonStatus } from 'src/selectors/polygon.selector';
import PolygonForm from '../polygon-form/polygon-form.component';
import style from '../polygon-list/polygon-list.module.scss';

type IProp = {
  data: IPolygon;
};

const PolygonEdit: React.FC<IProp> = ({ data }) => {
  const { state, actions } = usePolygonContext();
  const [isEditOpen, setIsEditOpen] = useState(false);
  const [isDirty, setIsDirty] = useState(false);
  const formRef = useRef<HTMLFormElement>(null);

  let defaultValues: Partial<IPolygon> = {
    polygon: '',
  };

  if (data) {
    defaultValues = data;
  }

  const editStatus = getPolygonStatus(state, actionTypes.POLYGON_UPDATE);

  const handleSave = useCallback(() => {
    if (formRef && formRef.current) {
      formRef.current.handleSubmit();
    }
  }, [formRef]);

  const handleSubmit = useCallback(
    async (value) => {
      const formData: IPolygonForm = {
        polygon: value.polygon,
      };
      const response = await actions.updatePUT(value.polygonId, formData);
      if (!response.error) {
        ToastSuccess(
          Lang.formatString(
            Lang.MSG_POLYGON_EDIT_SUCCESS,
            formData.polygon
          )
        );
      } else {
        ToastError(response.error.message);
      }
      setIsEditOpen(false);
      actions.listGET();
    },
    [actions, setIsEditOpen]
  );

  return (
    <ATMModal
      open={isEditOpen}
      size="tiny"
      trigger={
        <ATMButton
          className={style.actionIcon}
          basic
          icon="edit outline"
          onClick={() => setIsEditOpen(true)}
        />
      }
      header={Lang.LBL_EDIT_POLYGON}
      content={
        <div className={style.content}>
          <PolygonForm
            defaultValues={defaultValues}
            formRef={formRef}
            handleSubmit={handleSubmit}
            handleEnable={(value) => setIsDirty(value)}
          />
        </div>
      }
      actions={
        <div className={style.actionBtns}>
          <ATMButton
            basic
            color="blue"
            content={Lang.LBL_CANCEL}
            onClick={() => {
              setIsEditOpen(false);
            }}
          />
          <ATMButton
            primary
            content={Lang.LBL_SAVE}
            disabled={!isDirty || editStatus.fetching}
            onClick={handleSave}
            loading={editStatus.fetching}
          />
        </div>
      }
    />
  );
};

export default PolygonEdit;
